import { SelectInputV2, SelectInputV2Props } from '@frontend/basic-forms';
import { IoTActionName } from '@frontend/iot/types';
import React from 'react';

import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import useIoTActionSelect from './iot-action-select.controller';

const ID = 'iot-action-select';
export interface IoTActionSelectProps extends Omit<SelectInputV2Props<IoTActionName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const IoTActionSelect = (props: IoTActionSelectProps) => {
    const viewProps = useIoTActionSelect(props);

    return (
        <SelectInputV2<IoTActionName>
            {...props}
            id={ID + props.id}
            label={props.label || 'IoT action'}
            options={viewProps.options}
        />
    );
};

export default IoTActionSelect;
